/*
 *
 * DatasetEdit constants
 *
 */
export var GET_DATASET_REQUEST = 'app/DatasetEdit/GET_DATASET_REQUEST';
export var GET_DATASET_SUCCESS = 'app/DatasetEdit/GET_DATASET_SUCCESS';
export var GET_DATASET_FAILURE = 'app/DatasetEdit/GET_DATASET_FAILURE';
export var UPDATE_DATASET_REQUEST = 'app/DatasetEdit/UPDATE_DATASET_REQUEST';
export var UPDATE_DATASET_SUCCESS = 'app/DatasetEdit/UPDATE_DATASET_SUCCESS';
export var UPDATE_DATASET_FAILURE = 'app/DatasetEdit/UPDATE_DATASET_FAILURE';
export var UPDATE_DATASET_COLUMN_ORDER_REQUEST = 'app/DatasetEdit/UPDATE_DATASET_COLUMN_ORDER_REQUEST';
export var UPDATE_DATASET_COLUMN_ORDER_SUCCESS = 'app/DatasetEdit/UPDATE_DATASET_COLUMN_ORDER_SUCCESS';
export var UPDATE_DATASET_COLUMN_ORDER_FAILURE = 'app/DatasetEdit/UPDATE_DATASET_COLUMN_ORDER_FAILURE';
